
// import { useState, useCallback, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   useCreateLeadMutation,
//   useEditLeadByIdMutation,
//   useGetLeadByIdQuery,
// } from '@/features/api/leadsApi';
// import { Loader2 } from 'lucide-react';
// import { Button } from '@/components/ui/button';
// import { toast } from 'react-hot-toast';
// import LeadGenerationForm from './LeadGenerationForm';
// import EnrollmentInfoForm from './EnrollmentInfoForm';
// import DocumentationForm from './DocumentationForm';


// const AddNewLeads = () => {
//   const navigate = useNavigate();

//   // support both create & update
//   const [createLead, { isLoading: isCreating, error: createError }] = useCreateLeadMutation();
//   const [editLeadById, { isLoading: isUpdating, error: updateError }] = useEditLeadByIdMutation();

//   const [activeTab, setActiveTab] = useState(0);
//   const [completed, setCompleted] = useState(false);
//   const [formErrors, setFormErrors] = useState({});

//   // leadId may be stored in localStorage when editing
//   const [leadId, setLeadId] = useState(() => {
//     try {
//       return localStorage.getItem('currentLeadId') || null;
//     } catch {
//       return null;
//     }
//   });

//   // fetch lead if leadId exists (edit mode)
//   const { data: leadData, isLoading: isFetchingLead, error: fetchError } = useGetLeadByIdQuery(leadId, {
//     skip: !leadId,
//   });

//   const tabs = [
//     { key: 'leadGeneration', label: 'Lead Generation' },
//     { key: 'enrollmentInfo', label: 'Enrollment Info' },
//     { key: 'documentation', label: 'Documentation' },
//   ];

//   // canonical initial form keys (add more backend fields as needed)
//   const initialForm = {
//     firstName: '',
//     middleName: '',
//     lastName: '',
//     dob: '',
//     gender: '',
//     email: '',
//     address: '',
//     phone: '',
//     location: '',
//     emergencyContactName: '',
//     emergencyContactPhone: '',
//     emergencyContactEmail: '',
//     emergencyContactRelation: '',
//     service: '',
//     country: '',
//     program: '',
//     visaRejection: '',
//     travelHistory: '',
//     examType: '',
//     status: '',
//     payment: '',
//     documentationType: '',
//     gapUG: '',
//     gapPG: '',
//     examBooking: '',
//     // study abroad
//     passportPhotograph: '',
//     birthCertificate: '',
//     aadhaarCard: '',
//     passport: '',
//     cv: '',
//     sop: '',
//     // workpermit
//     passportPhotographWorkpermit: '',
//     birthCertificateWorkpermit: '',
//     aadhaarCardWorkpermit: '',
//     passportWorkpermit: '',
//     panCardWorkpermit: '',
//     pccWorkpermit: '',
//     cvWorkpermit: '',
//     workExperienceWorkpermit: '',
//     businessProofWorkpermit: '',
//     academicsWorkpermit: '',
//     salarySlipWorkpermit: '',
//     nocWorkpermit: '',
//     itrsWorkpermit: '',
//     bankStatementWorkpermit: '',
//     form16BWorkpermit: '',
//     marriageCertificateWorkpermit: '',
//     // tourist
//     bankStatementsTourist: '',
//     proofOfIncomeTourist: '',
//     companyDocsTourist: '',
//     invitationLetterTourist: '',
//     itineraryTourist: '',
//     coverLetterTourist: '',
//     // examBooking
//     Govrmentid: '',
//     passportExamBooking: '',
//     // add any additional fields from backend schema as needed
//   };

//   const [form, setForm] = useState(initialForm);

//   // fileFields grouped per service (controls which file keys are kept/cleared when switching)
//   const fileFieldsByService = {
//     studyAbroad: [
//       'passportPhotograph', 'birthCertificate', 'aadhaarCard', 'passport',
//       'cv', 'sop',
//       // add more studyAbroad-specific file keys if you use them
//     ],
//     workpermit: [
//       'passportPhotographWorkpermit','birthCertificateWorkpermit','aadhaarCardWorkpermit',
//       'passportWorkpermit','panCardWorkpermit','pccWorkpermit','cvWorkpermit','workExperienceWorkpermit',
//       'businessProofWorkpermit','academicsWorkpermit','salarySlipWorkpermit','nocWorkpermit','itrsWorkpermit',
//       'bankStatementWorkpermit','form16BWorkpermit','marriageCertificateWorkpermit',
//     ],
//     touristVisa: [
//       'bankStatementsTourist','proofOfIncomeTourist','companyDocsTourist','invitationLetterTourist',
//       'itineraryTourist','coverLetterTourist',
//     ],
//     examBooking: [
//       'Govrmentid','passportExamBooking'
//     ],
//     training: [], // no file keys to keep by default
//   };

//   // union of known file keys
//   const allFileKeys = Array.from(new Set(Object.values(fileFieldsByService).flat()));

//   //
//   // Load lead data (edit mode) and merge into form
//   //
//   useEffect(() => {
//     if (leadData) {
//       // normalize dob to YYYY-MM-DD for date inputs
//       const normalized = {
//         ...leadData,
//         dob: leadData?.dob ? new Date(leadData.dob).toISOString().split('T')[0] : '',
//       };

//       // merge only keys we recognize (keeps unknown backend keys but avoids unexpected shape)
//       setForm((prev) => ({ ...initialForm, ...prev, ...normalized }));
//       // ensure local leadId is set
//       if (!leadId && normalized._id) {
//         try { localStorage.setItem('currentLeadId', normalized._id); } catch {}
//         setLeadId(normalized._id);
//       }
//     }

//     if (fetchError) {
//       toast.error('Failed to fetch lead data: ' + (fetchError.data?.message || 'Unknown error'));
//       try {
//         localStorage.removeItem('leadFormData');
//         localStorage.removeItem('currentLeadId');
//         localStorage.removeItem('leadActiveTab');
//       } catch {}
//     }
//     // intentionally dependent on leadData & fetchError only
//   }, [leadData, fetchError]); // eslint-disable-line

//   // persist active tab
//   useEffect(() => {
//     try { localStorage.setItem('leadActiveTab', String(activeTab)); } catch {}
//   }, [activeTab]);

//   useEffect(() => {
//     try {
//       const savedTab = localStorage.getItem('leadActiveTab');
//       if (savedTab !== null) setActiveTab(Number(savedTab));
//     } catch {}
//   }, []);

//   // persist form locally (backup)
//   useEffect(() => {
//     try { localStorage.setItem('leadFormData', JSON.stringify(form)); } catch {}
//   }, [form]);

//   // restore when creating new (not editing)
//   useEffect(() => {
//     if (!leadId) {
//       try {
//         const saved = localStorage.getItem('leadFormData');
//         if (saved) setForm((prev) => ({ ...prev, ...JSON.parse(saved) }));
//       } catch {}
//     }
//   }, [leadId]);

//   // surface server errors for create/update
//   useEffect(() => {
//     if (createError) {
//       const msg =
//         createError.status === 413
//           ? 'Request too large. Please reduce file size or number of uploads.'
//           : createError.status === 500
//           ? 'Server error occurred. Please try again later.'
//           : `Failed to save lead: ${createError.data?.message || 'Check your input.'}`;
//       toast.error(msg);
//     }
//     if (updateError) {
//       const msg =
//         updateError.status === 413
//           ? 'Request too large. Please reduce file size or number of uploads.'
//           : updateError.status === 500
//           ? 'Server error occurred. Please try again later.'
//           : `Failed to update lead: ${updateError.data?.message || 'Check your input.'}`;
//       toast.error(msg);
//     }
//   }, [createError, updateError]);

//   //
//   // Validation
//   //
//   const validateFields = (stage = null) => {
//     const errors = {};
//     const stagesToValidate = stage ? [stage] : ['leadGeneration', 'enrollmentInfo', 'documentation'];

//     if (stagesToValidate.includes('leadGeneration')) {
//       if (!form.firstName) errors.firstName = 'First Name is required';
//       if (!form.lastName) errors.lastName = 'Last Name is required';
//       if (!form.gender) errors.gender = 'Gender is required';
//       if (!form.email || !/\S+@\S+\.\S+/.test(form.email)) errors.email = 'Valid Email is required';
//       if (!form.phone || !/^[0-9+\-() ]{7,}$/.test(form.phone)) errors.phone = 'Valid Phone is required';
//       if (!form.location) errors.location = 'Location is required';
//     }

//     if (stagesToValidate.includes('enrollmentInfo')) {
//       if (!form.service) errors.service = 'Service is required';
//       if (['studyAbroad', 'workpermit', 'touristVisa'].includes(form.service)) {
//         if (!form.country) errors.country = 'Country is required';
//         if (!form.status) errors.status = 'Status is required';
//       }
//       if (['examBooking', 'training'].includes(form.service) && !form.examType) {
//         errors.examType = 'Selection is required';
//       }
//     }

//     if (stagesToValidate.includes('documentation')) {
//       // training doesn't require docs
//       if (form.service !== 'training') {
//         if (!form.documentationType) errors.documentationType = 'Attachment Type is required';
//       }
//       // passport requirement for certain services
//       if (['studyAbroad', 'workpermit', 'touristVisa', 'examBooking'].includes(form.service)) {
//         const hasPassport =
//           Boolean(form.passport) ||
//           Boolean(form.passportWorkpermit) ||
//           Boolean(form.passportExamBooking) ||
//           Boolean(form.passportTourist) ||
//           Boolean(form.passportPhotograph) ||
//           Boolean(form.passportPhotographWorkpermit);
     
//       }
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

  
//   const handleChange = useCallback((eOrObj) => {
//     const target = eOrObj?.target ? eOrObj.target : eOrObj;
//     const { name, value } = target;

//     setForm((prev) => {
//       const next = { ...prev, [name]: value };

//       if (name === 'service') {
//         const keep = new Set(fileFieldsByService[value] || []);
//         allFileKeys.forEach((key) => {
//           if (!keep.has(key)) next[key] = ''; 
//         });

//         if (value === 'training') next.documentationType = '';
//         else next.documentationType = value || '';
//       }

//       return next;
//     });

//     setFormErrors((prev) => ({ ...prev, [target.name]: null }));
//   }, []); // constants are stable

  
//   const handleSave = async () => {
//     const currentStage = tabs[activeTab].key;
//     if (!validateFields(currentStage)) {
//       toast.error('Please fix the highlighted fields.');
//       return false;
//     }
//     return true;
//   };

//   //
//   // Final submit (create or update depending on leadId)
//   //
//   const handleNext = async () => {
//     const saved = await handleSave();
//     if (!saved) return;

//     if (activeTab < tabs.length - 1) {
//       setActiveTab((prev) => prev + 1);
//       return;
//     }

//     // final validation across all stages
//     if (!validateFields()) {
//       toast.error('Please complete all required fields.');
//       return;
//     }

//     // build formData for backend (your backend accepts FormData for file urls/fields)
//     const formData = new FormData();

//     // decide final stage: skip documentation for training
//     const finalStage = form.service === 'training' ? 'enrollmentInfo' : 'documentation';
//     formData.append('stage', finalStage);
//     formData.append('isFinal', 'true');
//     formData.append('isFinalized', 'true');

//     // ensure service is always included (schema relies on it)
//     if (form.service) formData.append('service', form.service);

//     // If documentationType is not set on frontend & service isn't training, backend pre-hook will fill it.
//     // Still safe to append it here for clarity.
//     if (form.service && form.service !== 'training') formData.append('documentationType', form.documentationType || form.service);

//     // Append all known fields (we send all keys to avoid partial update issues)
//     // Note: these are strings or already-uploaded file URLs (DocumentationForm returns fileUrl)
//     Object.keys(initialForm).forEach((key) => {
//       const val = form[key];
//       if (val !== undefined && val !== null && val !== '') {
//         if (key === 'dob') {
//           // send ISO datetime for dob
//           try {
//             const date = new Date(val);
//             if (!isNaN(date.getTime())) formData.append(key, date.toISOString());
//             else formData.append(key, val);
//           } catch {
//             formData.append(key, val);
//           }
//         } else {
//           formData.append(key, val);
//         }
//       }
//     });

//     try {
//       if (leadId) {
//         // update existing lead
//         await editLeadById({ id: leadId, data: formData }).unwrap();
//         toast.success('Lead updated successfully!');
//       } else {
//         // create new lead
//         const created = await createLead(formData).unwrap();
//         // if backend returns _id, save it so user can edit afterwards
//         try {
//           const newId = created?._id || created?.id;
//           if (newId) {
//             localStorage.setItem('currentLeadId', newId);
//             setLeadId(newId);
//           }
//         } catch {}
//         toast.success('Lead created successfully!');
//       }

//       setCompleted(true);
//       // cleanup saved local data
//       try {
//         localStorage.removeItem('leadFormData');
//         localStorage.removeItem('leadActiveTab');
//         // only remove currentLeadId if we created a lead and you want to clear edit mode
//         if (!leadId) localStorage.removeItem('currentLeadId');
//       } catch {}

//       setTimeout(() => navigate('/admin/leads', { state: { success: leadId ? 'Lead updated successfully!' : 'Lead created successfully!' } }), 1200);
//     } catch (err) {
//       console.error('Failed to create/update lead:', err);
//       toast.error(`Failed to create/update lead: ${err?.data?.message || err?.message || 'Unknown error'}`);
//     }
//   };

//   const handlePrevious = () => {
//     if (activeTab > 0) setActiveTab((prev) => prev - 1);
//   };

//   const handleTabClick = async (idx) => {
//     if (idx > activeTab) {
//       const ok = await handleSave();
//       if (!ok) return;
//     }
//     setActiveTab(idx);
//   };

//   const renderForm = () => {
//     const props = { form, handleChange, formErrors, isSaving: isCreating || isUpdating };
//     switch (tabs[activeTab].key) {
//       case 'leadGeneration':
//         return <LeadGenerationForm {...props} />;
//       case 'enrollmentInfo':
//         return <EnrollmentInfoForm {...props} />;
//       case 'documentation':
//         return <DocumentationForm {...props} />;
//       default:
//         return null;
//     }
//   };

//   if (isFetchingLead) {
//     return (
//       <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-xl min-h-screen text-center">
//         <Loader2 className="inline-block mr-2 h-6 w-6 animate-spin" />
//         Loading lead data...
//       </div>
//     );
//   }

//   const progressPercent = ((activeTab + 1) / tabs.length) * 100;

//   return (
//     <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-xl min-h-screen">
//       <h1 className="text-3xl font-bold text-center mb-4">{leadId ? '✏️ Edit Lead' : '➕ Add New Lead'}</h1>

//       <div className="w-full bg-gray-200 rounded-full h-2.5 mb-6">
//         <div className="bg-blue-600 h-2.5 rounded-full transition-all duration-300" style={{ width: `${progressPercent}%` }} />
//       </div>

//       <div className="flex justify-between mb-4">
//         {tabs.map((tab, idx) => (
//           <div
//             key={tab.key}
//             className={`cursor-pointer px-3 py-1 rounded-full text-sm font-semibold ${idx === activeTab ? 'bg-blue-600 text-white' : idx <= activeTab ? 'bg-gray-300 text-gray-800 hover:bg-gray-400' : 'bg-gray-200 text-gray-500'}`}
//             onClick={() => handleTabClick(idx)}
//           >
//             {tab.label}
//           </div>
//         ))}
//       </div>

//       <div className="bg-gray-50 rounded-lg p-6 shadow-sm min-h-[300px]">
//         {completed ? (
//           <div className="text-center py-20">
//             <h2 className="text-2xl font-bold mb-4 text-green-600">
//               <Loader2 className="inline-block mr-2 h-6 w-6 animate-spin" />
//               🎉 Lead successfully submitted!
//             </h2>
//             <Button variant="outline" onClick={() => navigate('/admin/leads')}>Go to Leads Dashboard</Button>
//           </div>
//         ) : (
//           <>
//             {formErrors.totalSize && <p className="text-red-500 text-center mb-4">{formErrors.totalSize}</p>}
//             {renderForm()}
//           </>
//         )}
//       </div>

//       {!completed && (
//         <div className="flex justify-between items-center mt-6">
//           {activeTab === 0 ? (
//             <Button variant="outline" disabled={activeTab === 0 || isCreating || isUpdating} onClick={() => navigate('/admin/leads')}>Back</Button>
//           ) : (
//             <Button variant="outline" disabled={activeTab === 0 || isCreating || isUpdating} onClick={handlePrevious}>Previous</Button>
//           )}

//           <Button onClick={handleNext} disabled={isCreating || isUpdating}>
//             {isCreating || isUpdating ? (
//               <>
//                 <Loader2 className="mr-2 h-4 w-4 animate-spin" />
//                 Saving...
//               </>
//             ) : activeTab === tabs.length - 1 ? 'Submit' : 'Next'}
//           </Button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AddNewLeads;


import { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  useCreateLeadMutation,
  useEditLeadByIdMutation,
  useGetLeadByIdQuery,
} from "@/features/api/leadsApi";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "react-hot-toast";
import LeadGenerationForm from "./LeadGenerationForm";
import EnrollmentInfoForm from "./EnrollmentInfoForm";
import DocumentationForm from "./DocumentationForm";

const AddNewLeads = () => {
  const navigate = useNavigate();

  // Create & Edit mutations
  const [createLead, { isLoading: isCreating, error: createError }] = useCreateLeadMutation();
  const [editLeadById, { isLoading: isUpdating, error: updateError }] = useEditLeadByIdMutation();

  // Tabs & active state
  const tabs = [
    { key: "leadGeneration", label: "Lead Generation" },
    { key: "enrollmentInfo", label: "Enrollment Info" },
    { key: "documentation", label: "Documentation" },
  ];
  const [activeTab, setActiveTab] = useState(0);
  const [completed, setCompleted] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  // Lead ID (edit mode)
  const [leadId, setLeadId] = useState(() => {
    try {
      return localStorage.getItem("currentLeadId") || null;
    } catch {
      return null;
    }
  });

  // Fetch lead data if editing
  const { data: leadData, isLoading: isFetchingLead, error: fetchError } = useGetLeadByIdQuery(
    leadId,
    { skip: !leadId }
  );

  // Form initial structure
  const initialForm = {
    firstName: "", middleName: "", lastName: "", dob: "", gender: "", email: "",
    address: "", phone: "", location: "", emergencyContactName: "",
    emergencyContactPhone: "", emergencyContactRelation: "",
    service: "", country: "", program: "", visaRejection: "", travelHistory: "",
    examType: "", ebd: "", anyspecificlocation: "", status: "", payment: "",
    // Documentation fields grouped by service
    passport: "", passportPhotograph: "", aadhaarCard: "", birthCertificate: "",
    cv: "", parentsPassport: "", itinerary: "", visaCopy: "", tenthResult: "",
    tenthPassingCertificate: "", eleventhResult: "", predictableMarksheet: "",
    twelfthResult: "", twelfthPassingCertificate: "", sop: "", coverLetter: "",
    languageExamCertificate: "", lorPrincipal: "", lorProfessor1: "", lorProfessor2: "",
    bachelorsMarksheets: "", predictableTranscript: "", transcript: "", bachelorsProvisional: "",
    bachelorsCertificate: "", wes: "", internshipWorkExperience: "", gap: "",
    bankStatements: "", bankManagerCertificate: "", itr: "", caNetworth: "", companyProof: "",
    sponsorDocs: "", loanSanctionLetter: "", otherDocumentStudyAbroad: "",
    passportWorkpermit: "", passportPhotographWorkpermit: "", aadhaarCardWorkpermit: "",
    panCardWorkpermit: "", birthCertificateWorkpermit: "", cvWorkpermit: "",
    travelHistoryWorkpermit: "", itineraryWorkpermit: "", visaCopyWorkpermit: "",
    pccWorkpermit: "", marriageCertificateWorkpermit: "", academicsWorkpermit: "",
    sopWorkpermit: "", coverLetterWorkpermit: "", languageExamCertificateWorkpermit: "",
    workExperienceWorkpermit: "", gapWorkpermit: "", nocWorkpermit: "",
    bankStatementWorkpermit: "", bankManagerCertificateWorkpermit: "", salarySlipWorkpermit: "",
    itrsWorkpermit: "", caNetworthWorkpermit: "", companyProofWorkpermit: "", otherDocumentWorkpermit: "",
    passportTourist: "", passportPhotographTourist: "", aadhaarCardTourist: "",
    birthCertificateTourist: "", cvTourist: "", travelHistoryTourist: "", itineraryTourist: "",
    visaCopyTourist: "", marriageCertificateTourist: "", academicsTourist: "", coverLetterTourist: "",
    workExperienceTourist: "", rejectionLetterTourist: "", nocTourist: "", bankStatementsTourist: "",
    bankManagerCertificateTourist: "", salarySlipTourist: "", itrsTourist: "", caNetworthTourist: "",
    companyDocsTourist: "", sponsorDocsTourist: "", otherDocumentTourist: "",
    Govrmentid: "", passportExamBooking: "",
  };
  const [form, setForm] = useState(initialForm);

  // File fields by service
  const fileFieldsByService = {
    studyAbroad: ["passport", "passportPhotograph", "aadhaarCard", "birthCertificate", "cv", "parentsPassport", "itinerary", "visaCopy", "tenthResult", "tenthPassingCertificate", "eleventhResult", "predictableMarksheet", "twelfthResult", "twelfthPassingCertificate", "sop", "coverLetter", "languageExamCertificate", "lorPrincipal", "lorProfessor1", "lorProfessor2", "bachelorsMarksheets", "predictableTranscript", "transcript", "bachelorsProvisional", "bachelorsCertificate", "wes", "internshipWorkExperience", "gap", "bankStatements", "bankManagerCertificate", "itr", "caNetworth", "companyProof", "sponsorDocs", "loanSanctionLetter", "otherDocumentStudyAbroad"],
    workpermit: ["passportWorkpermit", "passportPhotographWorkpermit", "aadhaarCardWorkpermit", "panCardWorkpermit", "birthCertificateWorkpermit", "cvWorkpermit", "travelHistoryWorkpermit", "itineraryWorkpermit", "visaCopyWorkpermit", "pccWorkpermit", "marriageCertificateWorkpermit", "academicsWorkpermit", "sopWorkpermit", "coverLetterWorkpermit", "languageExamCertificateWorkpermit", "workExperienceWorkpermit", "gapWorkpermit", "nocWorkpermit", "bankStatementWorkpermit", "bankManagerCertificateWorkpermit", "salarySlipWorkpermit", "itrsWorkpermit", "caNetworthWorkpermit", "companyProofWorkpermit", "otherDocumentWorkpermit"],
    touristVisa: ["passportTourist", "passportPhotographTourist", "aadhaarCardTourist", "birthCertificateTourist", "cvTourist", "travelHistoryTourist", "itineraryTourist", "visaCopyTourist", "marriageCertificateTourist", "academicsTourist", "coverLetterTourist", "workExperienceTourist", "rejectionLetterTourist", "nocTourist", "bankStatementsTourist", "bankManagerCertificateTourist", "salarySlipTourist", "itrsTourist", "caNetworthTourist", "companyDocsTourist", "sponsorDocsTourist", "otherDocumentTourist"],
    examBooking: ["Govrmentid", "passportExamBooking"],
    training: [],
  };
  const allFileKeys = Array.from(new Set(Object.values(fileFieldsByService).flat()));

  // Load existing lead (edit mode)
  useEffect(() => {
    if (leadData) {
      const normalized = { ...leadData, dob: leadData.dob ? new Date(leadData.dob).toISOString().split("T")[0] : "" };
      setForm((prev) => ({ ...initialForm, ...normalized }));
      if (!leadId && normalized._id) {
        try { localStorage.setItem("currentLeadId", normalized._id); setLeadId(normalized._id); } catch {}
      }
    }
    if (fetchError) {
      toast.error(`Failed to fetch lead data: ${fetchError.data?.message || "Unknown error"}`);
      setForm(initialForm);
      try { localStorage.removeItem("leadFormData"); localStorage.removeItem("currentLeadId"); localStorage.removeItem("leadActiveTab"); } catch {}
    }
  }, [leadData, fetchError]);

  // Persist & restore active tab
  useEffect(() => { try { localStorage.setItem("leadActiveTab", String(activeTab)); } catch {} }, [activeTab]);
  useEffect(() => { try { const savedTab = localStorage.getItem("leadActiveTab"); if (savedTab !== null) setActiveTab(Number(savedTab)); } catch {} }, []);

  // Persist & restore form locally
  useEffect(() => { try { localStorage.setItem("leadFormData", JSON.stringify(form)); } catch {} }, [form]);
  useEffect(() => { if (!leadId) { try { const saved = localStorage.getItem("leadFormData"); if (saved) { const parsed = JSON.parse(saved); if (parsed) setForm((prev) => ({ ...initialForm, ...parsed })); } } catch { setForm(initialForm); } } }, [leadId]);

  // Handle API errors
  useEffect(() => {
    const handleServerError = (error, action) => {
      if (!error) return;
      const msg = error.status === 413 ? "Request too large. Reduce file size or uploads." :
                  error.status === 500 ? "Server error. Try later." :
                  error.status === 400 && error.data?.message.includes("Unexpected token") ? "Invalid data format." :
                  `Failed to ${action} lead: ${error.data?.message || "Check input."}`;
      toast.error(msg);
      if (error.data?.errors) setFormErrors((prev) => ({ ...prev, ...error.data.errors }));
    };
    handleServerError(createError, "create");
    handleServerError(updateError, "update");
  }, [createError, updateError]);

  // Validate fields
  const validateFields = useCallback((stage = null) => {
    const errors = {};
    const stagesToValidate = stage ? [stage] : ["leadGeneration", "enrollmentInfo", "documentation"];
    if (stagesToValidate.includes("leadGeneration")) {
      if (!form.firstName) errors.firstName = "Required";
      if (!form.lastName) errors.lastName = "Required";
      if (!form.gender) errors.gender = "Required";
      if (!form.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errors.email = "Valid email required";
      if (!form.phone || !/^\+?[0-9]{10,15}$/.test(form.phone)) errors.phone = "Phone 10-15 digits required";
      if (!form.location || !["Vesu","Varachha","Other"].includes(form.location)) errors.location = "Required location";
    }
    if (stagesToValidate.includes("enrollmentInfo")) {
      if (!form.service || !["studyAbroad","workpermit","touristVisa","examBooking","training"].includes(form.service)) errors.service="Required";
      if (['studyAbroad','workpermit','touristVisa'].includes(form.service)) {
        if (!form.country) errors.country="Required";
        if (!form.status || !["registration","onHold","closed","cold"].includes(form.status)) errors.status="Required";
      }
    }
    if (stagesToValidate.includes("documentation")) {
      allFileKeys.forEach(key => { if (form[key] && !/^(https?:\/\/|\/)/.test(form[key])) errors[key] = `${key} must be valid path/URL`; });
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  }, [form, allFileKeys]);

  // Handle changes
  const handleChange = useCallback(eOrObj => {
    const target = eOrObj?.target ? eOrObj.target : eOrObj;
    let { name, value } = target;
    if (typeof value === "string") value = value.trim();
    setForm(prev => {
      const next = { ...prev, [name]: value };
      if (name === "service") {
        const keep = new Set(fileFieldsByService[value] || []);
        allFileKeys.forEach(k => { if (!keep.has(k)) next[k]=""; });
      }
      return next;
    });
    setFormErrors(prev => ({ ...prev, [name]: null }));
  }, [allFileKeys]);

  // Handle tab navigation & child submission
  const handleChildSubmit = useCallback(childFormData => { setForm(prev => ({ ...prev, ...childFormData })); if (activeTab<tabs.length-1) setActiveTab(prev=>prev+1); else handleNext(); }, [activeTab,tabs.length]);
  const handlePrevious = useCallback(()=>{ if(activeTab>0) setActiveTab(prev=>prev-1); },[activeTab]);
  const handleTabClick = useCallback(async idx=>{ if(idx>activeTab){ const ok = await handleSave(); if(!ok) return; } setActiveTab(idx); },[activeTab]);
  const handleBack = useCallback(()=>{ if(Object.values(form).some(v=>v!=="")){ if(!window.confirm("Unsaved changes. Leave?")) return; } navigate("/admin/leads"); },[form,navigate]);
  
  // Save current stage
  const handleSave = useCallback(async()=>{ const stage = tabs[activeTab].key; if(!validateFields(stage)){ toast.error("Fix highlighted fields"); return false; } return true; },[activeTab,tabs,validateFields]);

  // Handle Next/Submit
  const handleNext = useCallback(async()=>{
    if(!(await handleSave())) return;
    if(activeTab<tabs.length-1){ setActiveTab(prev=>prev+1); return; }
    if(!validateFields()) { toast.error("Complete all required fields"); return; }

    const formData = new FormData();
    const finalStage = form.service==="training"?"enrollmentInfo":"documentation";
    formData.append("stage", finalStage);
    formData.append("isFinal","true"); formData.append("isFinalized","true");
    if(form.service) formData.append("service",form.service);
    if(form.service && form.service!=="training") formData.append("documentationType",form.service);

    Object.keys(initialForm).forEach(key=>{
      const val=form[key];
      if(val!==undefined && val!==null && val!==""){
        if(key==="dob"){ const date=new Date(val); if(!isNaN(date.getTime())) formData.append(key,date.toISOString()); else throw new Error("Invalid DOB"); }
        else if(allFileKeys.includes(key)){ if(typeof val==="string" && /^(https?:\/\/|\/)/.test(val)) formData.append(key,val); }
        else formData.append(key,val);
      }
    });

    try{
      if(leadId) await editLeadById({id:leadId,data:formData}).unwrap();
      else { const created = await createLead(formData).unwrap(); if(created?._id) { setLeadId(created._id); localStorage.setItem("currentLeadId",created._id); } }
      toast.success(leadId?"Lead updated!":"Lead created!");
      setCompleted(true);
      try { localStorage.removeItem("leadFormData"); localStorage.removeItem("leadActiveTab"); if(!leadId) localStorage.removeItem("currentLeadId"); } catch {}
      setTimeout(()=>navigate("/admin/leads",{state:{success:leadId?"Lead updated!":"Lead created!"}}),1200);
    }catch(err){ toast.error(`Failed: ${err?.data?.message||err?.message||"Unknown"}`); }
  },[activeTab,form,leadId,createLead,editLeadById,navigate,allFileKeys,validateFields]);

  // Render active form
  const renderForm = useCallback(()=>{
    const props={form,handleChange,formErrors,isSaving:isCreating||isUpdating,onSubmit:handleChildSubmit};
    switch(tabs[activeTab].key){ case "leadGeneration": return <LeadGenerationForm {...props}/>; case "enrollmentInfo": return <EnrollmentInfoForm {...props}/>; case "documentation": return <DocumentationForm {...props}/>; default: return null; }
  },[activeTab,form,formErrors,isCreating,isUpdating,handleChildSubmit,tabs]);

  if(isFetchingLead) return <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-xl min-h-screen text-center"><Loader2 className="inline-block mr-2 h-6 w-6 animate-spin"/> Loading lead data...</div>;

  const progressPercent=((activeTab+1)/tabs.length)*100;

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-xl min-h-screen">
      <h1 className="text-3xl font-bold text-center mb-4">{leadId?"✏️ Edit Lead":"➕ Add New Lead"}</h1>
      <div className="w-full bg-gray-200 rounded-full h-2.5 mb-6" role="progressbar" aria-label="Form progress" aria-valuenow={progressPercent} aria-valuemin="0" aria-valuemax="100">
        <div className="bg-blue-600 h-2.5 rounded-full transition-all duration-300" style={{width:`${progressPercent}%`}}/>
      </div>

      <div className="flex justify-between mb-4" role="tablist" aria-label="Form sections">
        {tabs.map((tab,idx)=>(
          <button key={tab.key} role="tab" aria-selected={idx===activeTab} className={`cursor-pointer px-3 py-1 rounded-full text-sm font-semibold ${idx===activeTab?"bg-blue-600 text-white":idx<=activeTab?"bg-gray-300 text-gray-800 hover:bg-gray-400":"bg-gray-200 text-gray-500"}`} onClick={()=>handleTabClick(idx)} disabled={isCreating||isUpdating}>{tab.label}</button>
        ))}
      </div>

      <div className="bg-gray-50 rounded-lg p-6 shadow-sm min-h-[300px]">
        {completed ? (
          <div className="text-center py-20" aria-live="polite">
            <h2 className="text-2xl font-bold mb-4 text-green-600"><Loader2 className="inline-block mr-2 h-6 w-6 animate-spin"/> 🎉 Lead successfully submitted!</h2>
            <Button variant="outline" onClick={()=>navigate("/admin/leads")}>Go to Leads Dashboard</Button>
          </div>
        ) : (
          <>
            {formErrors.totalSize && <p className="text-red-500 text-center mb-4">{formErrors.totalSize}</p>}
            {renderForm()}
          </>
        )}
      </div>

      {!completed && <div className="flex justify-between items-center mt-6">
        {activeTab===0?<Button variant="outline" disabled={isCreating||isUpdating} onClick={handleBack}>Back</Button>:<Button variant="outline" disabled={isCreating||isUpdating} onClick={handlePrevious}>Previous</Button>}
        <Button onClick={handleNext} disabled={isCreating||isUpdating}>{isCreating||isUpdating?(<><Loader2 className="mr-2 h-4 w-4 animate-spin"/> Saving...</>):activeTab===tabs.length-1?"Submit":"Next"}</Button>
      </div>}
    </div>
  );
};

export default AddNewLeads;


